var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 comments-datatable"},[_c('app-table',{attrs:{"id":_vm.tableId,"id":"comments-table","filtered-data":_vm.filteredData,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }